<template>
  <b-container
    v-if="render"
    fluid
  >
    <b-card title="Filtro">
      <b-row>
        <b-col
          sm="12"
          md="12"
          xl="auto"
          offset-xxl="0"
        >
          <b-form-group>
            <b-form-datepicker
              id="dt-start"
              v-model="inicialDate"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              placeholder="Selecione a Data Inicial"
              @input="filterMain()"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="12"
          xl="auto"
          offset-xxl="0"
        >
          <b-form-group>
            <b-form-datepicker
              id="dt-end"
              v-model="finalDate"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              placeholder="Selecione a Data Final"
              @input="filterMain()"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="12"
          xl="auto"
          offset-xxl="0"
        >
          <b-form-group>
            <b-form-select
              v-model="transactionFilter"
              :options="typeTransaction"
              @change="filterMain()"
            />
          </b-form-group>
        </b-col>
        <b-col
          sm="12"
          md="12"
          xl="auto"
          offset-xl="0"
        >
          <b-form-group>
            <b-form-select
              v-model="statusFilter"
              :options="typeStatus"
              @change="filterMain()"
            />
          </b-form-group>
        </b-col>

        <b-col
          v-if="transactionFilter === 'Boleto'"
          sm="12"
          md="12"
          xl="4"
          offset-xxl="0"
        >
          <b-form-group>
            <b-form-input
              v-model="customerFilter"
              placeholder="Cliente"
              @change="filterMain"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-table
        lg
        hover
        :fields="fields"
        :items="items"
        :per-page="perPage"
        :current-page="currentPage"
        responsive="xl"
        class="text-center"
        @row-clicked="linkDetails"
      >

        <template #cell(index)="data">
          {{ data.index }}
        </template>

        <template #cell(name)="data">
          {{ data.item.customer_name }}
        </template>
        <template #cell(e-mail)="data">
          {{ data.value.email }}
        </template>

        <template #cell(data)="data">
          {{ data.value.transactionDate }}
        </template>
        <template #cell(type)="data">
          {{ data.value.type }}
        </template>

        <template #cell(status)="data">
          <b-badge
            pill
            :variant="data.item.status_id.variant"
          >
            {{ data.item.status_id.status }}
          </b-badge>
        </template>

        <template #cell(value)="data">
          {{ data.value }}
        </template>

      </b-table>

      <div
        v-if="isEmpty"
        class="text-center mb-1"
      > Você ainda não possui cobranças. <a
        class="a-view-products"
        href="/novas-cobrancas"
      > Clique aqui para gerar uma nova cobrança </a> </div>
      <b-pagination
        v-model="currentPage"
        align="center"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      />
    </b-card>
  </b-container>
</template>
<script>
import {
  BRow,
  BContainer,
  BCol,
  BFormGroup,
  BFormDatepicker,
  BCard,
  BFormSelect,
  BFormInput,
  BPagination,
  BTable,
  BBadge,
} from 'bootstrap-vue'

import { DateTime } from 'luxon'
import { callLoading } from '@/service/utilities/utilities'

import { getAll } from '@/service/transaction/transaction'

export default {
  components: {
    BRow,
    BContainer,
    BCol,
    BFormGroup,
    BFormDatepicker,
    BCard,
    BFormSelect,
    BTable,
    BBadge,
    BPagination,
    BFormInput,
  },
  data() {
    return {
      render: false,
      isLoading: true,
      inicialDate: '',
      finalDate: '',
      search: '',
      perPage: 10,
      itemsBackup: [],
      currentPage: 1,
      rows: 0,
      transactionFilter: '',
      statusFilter: '',
      filter: '',
      isEmpty: false,
      customerFilter: '',
      typeTransaction: [{
        value: '',
        text: 'Selecione o tipo da transação',
      }],
      typeStatus: [{
        value: '',
        text: 'Selecione o status',
      }],
      fields: [{
        key: 'id',
        label: 'Pedido',
      },
      {
        key: 'name',
        label: 'Cliente',
      },
      {
        key: 'email',
        label: 'E-mail',
      },
      {
        key: 'created_at',
        label: 'Data da Transação',
      },
      {
        key: 'order_type',
        label: 'Tipo de Transação',
      },
      {
        key: 'status',
        label: 'Status',
      },
      {
        key: 'value',
        label: 'Valor',
      },
      ],
      items: [],
    }
  },
  async mounted() {
  callLoading(true)

  await this.getTransactions(1)

  // Define o limite máximo de páginas a carregar
  const limit = Math.min(this.pagesCount, 10)

  for (let i = 2; i <= limit; i++) {
    await this.getTransactions(i)
  }

  this.items = this.items.sort((a, b) => b.id - a.id)
  this.render = true
  this.itemsBackup = this.items
  callLoading(false)
},

  methods: {
    async getTransactions(index) {
      const res = await getAll(index)
      if (res.data.data.length <= 0) {
        this.isEmpty = true
        return
      }
      this.pagesCount = res.data.meta.last_page
      this.rows = res.data.meta.total

      const orderType = {
        TRANSACTION: 'Transação',
        BANKSLIP: 'Boleto',
        RECURRENCE: 'Recorrência',
      }

      const status = {
        1: {
          status: 'Aprovado',
          variant: 'success',
        },
        2: {
          status: 'Não Autorizado',
          variant: 'danger',
        },
        3: {
          status: 'Revisão',
          variant: 'warning',
        },
        4: {
          status: 'Aguardando Pagamento',
          variant: 'secondary',
        },
        5: {
          status: 'Aguardando Pagamento',
          variant: 'secondary',
        },
        7: {
          status: 'Falha na Captura',
          variant: 'danger',
        },
        8: {
          status: 'Falha na Recorrência',
          variant: 'danger',
        },
        9: {
          status: 'Criado',
          variant: 'success',
        },
        10: {
          status: 'Inativa',
          variant: 'danger',
        },
        11: {
          status: 'Aguardando Pagamento',
          variant: 'secondary',
        },
        12: {
          status: 'Expirado',
          variant: 'danger',
        },
        13: {
          status: 'Pago',
          variant: 'success',
        },
        14: {
          status: 'Baixado',
          variant: 'danger',
        },
        22: {
          status: 'Aguardando Confirmação',
          variant: 'danger'
        }
      }
      // traverse transaction array
      const { data } = res.data
      data.forEach(item => {
        let transaction = item

        const { customer_name, email } = item.payment_link?.customer || item.bankslip?.customer || item.recurrence_link.customer
        const { status_id, value } = item?.payment_link || item?.bankslip || item.recurrence_link

        const formatter = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        })

        transaction = Object.assign(transaction, {
          customer_name,
          email,
          status_id,
          value: formatter.format(value),
        })

        transaction.created_at = DateTime.fromISO(transaction.created_at).toFormat(
          'dd/MM/yyyy',
        )

        transaction.order_type = orderType[transaction.order_type]

        transaction.status_id = status[transaction.status_id]

        if (!this.typeStatus.some(typeStatus => typeStatus.value === transaction.status_id?.status)) {
          this.typeStatus.push({
            value: transaction.status_id.status,
            text: transaction.status_id.status,
          })
        }

        if (!this.typeTransaction.some(typeTransaction => typeTransaction.value === transaction.order_type)) {
          this.typeTransaction.push({
            value: transaction.order_type,
            text: transaction.order_type,
          })
        }

        this.items.push(transaction)
      })
      this.typeStatus.sort((a, b) => ((a.value).localeCompare(b.value)))
      this.typeTransaction.sort((a, b) => ((a.value).localeCompare(b.value)))
    },

    async filterMain() {
      callLoading(true)
      this.items = this.itemsBackup
      this.rows = this.items.length

      if (this.transactionFilter) {
        this.transactionFilterWatch()
      }
      if (this.statusFilter) {
        this.statusFilterWatch()
      }
      if (this.inicialDate) {
        this.inicialDateFilterWatch()
      }
      if (this.finalDate) {
        this.finalDateFilterWatch()
      }

      if (this.customerFilter && this.transactionFilter === 'Boleto') {
        this.customerNameFilterWatch()
      } else {
        this.customerFilter = ''
      }

      this.currentPage = 1
      this.rows = this.items.length
      callLoading(false)
    },

    transactionFilterWatch() {
      const { items } = this
      const filtered = items.filter(item => item.order_type === this.transactionFilter)
      this.items = filtered
    },
    // filter status
    statusFilterWatch() {
      const { items } = this
      const filtered = items.filter(item => item.status_id.status === this.statusFilter)
      this.items = filtered
    },

    inicialDateFilterWatch() {
      const { items } = this
      const filtered = items.filter(item => {
        const arrayDate = item.created_at.split('/')
        const dateItem = `${arrayDate[2]}-${arrayDate[1]}-${arrayDate[0]}`
        const filterDate = DateTime.fromISO(this.inicialDate).toFormat(
          'yyyy-MM-dd',
        )
        return dateItem >= filterDate
      })
      this.items = filtered
    },

    finalDateFilterWatch() {
      const { items } = this
      const filtered = items.filter(item => {
        const arrayDate = item.created_at.split('/')
        const dateItem = `${arrayDate[2]}-${arrayDate[1]}-${arrayDate[0]}`
        const filterDate = DateTime.fromISO(this.finalDate).toFormat(
          'yyyy-MM-dd',
        )
        return dateItem <= filterDate
      })
      this.items = filtered
    },

    customerNameFilterWatch() {
      const { items } = this
      const filtered = items.filter(item => {
        const { customer_name: name } = item
        if (!name) {
          return false
        }

        const nameLowerCase = name.toLowerCase()
        const customerFilterLowerCase = this.customerFilter.toLowerCase()
        return nameLowerCase.includes(customerFilterLowerCase)
      })
      this.items = filtered
    },

    linkDetails(item) {
      let link
      const { order_type: order } = item
      if (order === 'Transação') {
        link = `link-pagamento/${item.payment_link.hash}`
      } else if (order === 'Recorrência') {
        link = `recorrencia/${item.recurrence_link.hash}`
      } else if (order === 'Boleto') {
        link = `boleto/${item.bankslip.bar_code}`
      }
      this.$router.push({
        path: `/cobranca/minha/${link}`,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
  @import "@core/scss/vue/pages/transaction-style.scss";
</style>
